import { normalize, schema } from 'normalizr';
import api from '../api';

const MODULES_LIST_SUCCESS = api.events.modulesList.actionSuccess;

//const lessonPageSchema = new schema.Entity('lessonPages');
/*const lessonSchema = new schema.Entity('lessons', {
  pages: [lessonPageSchema]
});*/
//const introPageSchema = new schema.Entity('introPages');
const moduleSchema = new schema.Entity('modules');

// Appending lessons to the modules array, I think
// {
//   introPages: [introPageSchema],
//   lessons: [lessonSchema]
// }

const moduleListSchema = new schema.Array(moduleSchema);

const defaultState = { modules: [] };

export default function(state = defaultState, action) {
  switch (action.type) {
    case MODULES_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, moduleListSchema);

      let newState = {
        modules: [...action.data], // may have to update this, leaving for now
      };

      if (newState.modules) {
        newState = {
          modules: newState.modules,
          lessons: {
            ...state.lessons,
            ...normalizedData.entities.lessons
          },
          introPages: {
            ...state.introPages,
            ...normalizedData.entities.introPages
          },
          lessonPages: {
            ...state.lessonPages,
            ...normalizedData.entities.lessonPages
          }
        }
      }

      return newState;
    }
    default:
      return state;
  }
}
